export const formatMoney = (payload) => {
    return 'IDR '+payload.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");;
}